import React, { lazy, Suspense, useContext } from "react";
import { AppState } from "../lib/context/AppProvider";
import OptHeader from "./OptHeader";
import { convertMarkdownLineBreaks, getMotdTooltipText } from "../utils/general";

// react-markdown pulls in the whole remark/unified toolchain; lazy-load it so
// this always-mounted header doesn't drag it into the entry bundle.
const ReactMarkdown = lazy(() => import("react-markdown"));

const MotdHeaders = () => {
    const {motds} = useContext(AppState);

    return motds?.filter((motd) => motd.ShowBanner)?.map((motd) => {
        const tooltipText = convertMarkdownLineBreaks(getMotdTooltipText(motd));
        return <OptHeader
            key={motd.Id}
            backgroundColor={motd.Color ?? "#EEFF00"}
            text={motd.Title}
            tooltip={<span className="child-p-no-margin">
                    <Suspense fallback={tooltipText}>
                        <ReactMarkdown>
                            {tooltipText}
                        </ReactMarkdown>
                    </Suspense>
                </span>}
        />;
    });
};

MotdHeaders.propTypes = {};

export default MotdHeaders;
